import React from 'react';
import MultipleTagsInput from '../common/inputs/multipleTagsInput';
import DateFilter from '../common/dateFilter';

const Header = props =>
  !props.loadingFilter ? (
    <div className="header">
      <div className="box-form islabel box170">
        <div>
          <label>{props.language.group}</label>
        </div>
        <div>
          <select
            value={props.select.toLowerCase()}
            id="group"
            data-type="select"
            onChange={props.handleSubmit}
          >
            {props.group.map((item, i) => (
              <option value={item} key={`group-${i}`}>
                {props.language[item.toLowerCase()]}
              </option>
            ))}
          </select>
        </div>
      </div>
      <MultipleTagsInput
        categories={props.filter}
        filteredTags={props.filters.tags}
        language={props.language}
        handleSubmit={props.handleSubmit}
        isMultiple={true}
      />
      <div className="box-form islabel box170">
        <div>
          <label>{props.language.from}</label>
        </div>
        <div>
          <DateFilter
            date={
              props.filters.date.fechaStartFinal
                ? props.filters.date.fechaStartFinal
                : props.date.response
                ? props.date.response.maxDate.substring(0, 10)
                : new Date()
            }
            dif={props.filters.date.fechaStartFinal ? 0 : -1123200000}
            id="date-start"
            handleSubmit={props.handleSubmit}
          />
        </div>
      </div>
      <div className="box-form islabel box170">
        <div>
          <label>{props.language.to}</label>
        </div>
        <div>
          <DateFilter
            date={
              props.filters.date.fechaEndFinal
                ? props.filters.date.fechaEndFinal
                : props.date.response
                ? props.date.response.maxDate.substring(0, 10)
                : new Date()
            }
            dif={0}
            id="date-end"
            handleSubmit={props.handleSubmit}
          />
        </div>
      </div>
    </div>
  ) : (
    <div className="header" />
  );

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/summary_fatigue/header.jsx